import React, { useContext } from "react";
import Tablecomp from "../comp/Table";
import { render } from "sass";
import { contextData } from "../Context";

const ContactList = () => {
  const columnConfig = [
    {
      title: "id",
      dataIndex: "cid",
      key: "cid",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      isSearchable: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      isSearchable: true,
    },
    {
      title: "Contact",
      dataIndex: "contact",
      key: "contact",
      isSearchable: true,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      isSearchable: true,
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <textarea disabled>{record.message}</textarea>
        </div>
      ),
    },
  ];

  const conData = useContext(contextData);

  return (
    <>
      <Tablecomp columnConfig={columnConfig} tableData={conData.contactData} />
    </>
  );
};

export default ContactList;
